module.exports = __webpack_public_path__ + "img/color_block_10.4ed10464.svg";